import Vue from 'vue'
import App from './App.vue'
import router from './router'
//import './plugins/element.js'

import './css/font-awesome-4.3.0/css/font-awesome.min.css'
import './css/dist/css/bootstrap.min.css'
import './css/common.less'


import store from './store'


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')


router.beforeEach((to, from, next) => {
  // to: Route: 即将要进入的目标 路由对象
  // from: Route: 当前导航正要离开的路由
  // next: Function: 一定要调用该方法来 resolve 这个钩子。执行效果依赖 next 方法的调用参数。
  
  let isLogin = localStorage.userid //是否登录
  // let isLogin = store.state.token //是否登录
  if (isLogin === undefined && to.path !== '/login') next('/login');
  else next();
});
